import React, { Component } from 'react';
import './sidebar.css';
import Client from './client/client.js';
import SidebarControlPanel from './sidebarControlPanel/sidebarControlPanel';

class Sidebar extends Component {

  state = {
    chosenLabel: 'InstanceId',
    loadingMessage: 'LOADING',
    roleFilter: {
      '*NO ROLE*': false,
      'DR': false,
      'Development': false,
      'Production': false,
      'QA': false,
    }
  }

  // Shows a loading indicator in the sidebar when instances are being loaded in.
  componentDidUpdate() {

    const {loading} = this.props;
    const {loadingMessage} = this.state;

    if (loading) {

      setTimeout(() => {
        if (loadingMessage === 'LOADING') this.setState({loadingMessage: 'LOADING.'});
        else if (loadingMessage === 'LOADING.') this.setState({loadingMessage: 'LOADING..'});
        else if (loadingMessage === 'LOADING..') this.setState({loadingMessage: 'LOADING...'});
        else if (loadingMessage === 'LOADING...') this.setState({loadingMessage: 'LOADING'});
      }, 1000);

    }

  }

  // Handles switching between displaying the instance name and ID.
  switchChosenLabel = () => {
    if (this.state.chosenLabel === 'InstanceId') this.setState({chosenLabel: 'name'});
    else this.setState({chosenLabel: 'InstanceId'});
  }

  // A function to pass down as a prop to update the local state.
  updateSidebarState = object => this.setState(object);

  render() {

    const {
      switchChosenLabel,
      updateSidebarState
    } = this;

    const {
      addToMonitoring,
      instances,
      loading,
      monitoring,
      removeFromMonitoring,
    } = this.props;

    const {
      chosenLabel,
      loadingMessage,
      roleFilter,
    } = this.state;

    const clients = instances.reduce((acc, instance) => {
      if (!acc.includes(instance.accountName)) acc.push(instance.accountName);
      return acc;
    }, []);

    return (
      <div className="Sidebar">
        <SidebarControlPanel
          switchChosenLabel={switchChosenLabel}
          chosenLabel={chosenLabel}
          roleFilter={roleFilter}
          updateSidebarState={updateSidebarState}
        />
        {loading && <p className="LoadingMessage">{loadingMessage}</p>}
        {clients.sort().map(client => {
          return <Client
            key={client}
            client={client}
            instances={instances.filter(instance => instance.accountName === client)}
            addToMonitoring={addToMonitoring}
            removeFromMonitoring={removeFromMonitoring}
            monitoring={monitoring}
            chosenLabel={chosenLabel}
            roleFilter={roleFilter}
          />;
        })}
      </div>
    );
  }

}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/sidebar/sidebar.js